// Accurate date calculation utilities with leap year support

export const isLeapYear = (year) => {
  return (year % 4 === 0 && year % 100 !== 0) || (year % 400 === 0);
};

export const getDaysInMonth = (year, month) => {
  const daysInMonths = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
  if (month === 1 && isLeapYear(year)) {
    return 29;
  }
  return daysInMonths[month];
};

export const calculateTimeDifference = (startDate, endDate) => {
  const start = new Date(startDate);
  const end = new Date(endDate);
  
  // Calculate total days difference for seconds, minutes, hours
  const diffMs = end - start;
  const totalSeconds = Math.floor(diffMs / 1000);
  const totalMinutes = Math.floor(totalSeconds / 60);
  const totalHours = Math.floor(totalMinutes / 60);
  const totalDays = Math.floor(totalHours / 24);
  
  // Calculate years, months, and days with proper date logic
  let years = end.getFullYear() - start.getFullYear();
  let months = end.getMonth() - start.getMonth();
  let days = end.getDate() - start.getDate();
  
  // Handle negative days
  if (days < 0) {
    months--;
    const previousMonth = end.getMonth() === 0 ? 11 : end.getMonth() - 1;
    const previousYear = end.getMonth() === 0 ? end.getFullYear() - 1 : end.getFullYear();
    days += getDaysInMonth(previousYear, previousMonth);
  }
  
  // Handle negative months
  if (months < 0) {
    years--;
    months += 12;
  }
  
  // Calculate remaining time components
  const hours = end.getHours() - start.getHours();
  const minutes = end.getMinutes() - start.getMinutes();
  const seconds = end.getSeconds() - start.getSeconds();
  
  return {
    years,
    months,
    days,
    hours: hours < 0 ? 24 + hours : hours,
    minutes: minutes < 0 ? 60 + minutes : minutes,
    seconds: seconds < 0 ? 60 + seconds : seconds,
    totalDays,
    totalHours,
    totalMinutes,
    totalSeconds,
    totalWeeks: Math.floor(totalDays / 7)
  };
};

export const formatNumber = (num) => {
  return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};